import type { DefaultParams } from 'modules/bookkeepers/hooks/useIncidenceFilters'
import { IncidenceFilterProvider } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import { MessageFilterProvider } from 'modules/bookkeepers/lib/MessageFilterContext'
import { SORT_ATTRIBUTES } from 'modules/bookkeepers/lib/tableSortColumns'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PolicyPeriodDashboardContent from 'modules/payroll_bundle/components/PolicyPeriodDashboardContent'
import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'
import {
  INCIDENCE_STATUSES,
  INHOUSE_INCIDENCE_STATUSES,
} from 'modules/payroll_bundle/lib/Incidences/Status'

const PolicyPeriodDashboardPage = () => {
  const { hasInhousePayroll } = useInhousePayroll()

  const defaultIncidencesFilterValues: DefaultParams = {
    filters: {
      status: hasInhousePayroll
        ? INHOUSE_INCIDENCE_STATUSES.to_do
        : INCIDENCE_STATUSES.in_preparation,
    },
    direction: 'asc',
    attribute: SORT_ATTRIBUTES.incidence_effective_date,
  }

  const defaultMessagesFilterValues: DefaultParams = {
    direction: 'desc',
    containsMessage: true,
    attribute: SORT_ATTRIBUTES.incidence_effective_date,
  }

  return (
    <IncidenceFilterProvider defaultFilterValues={defaultIncidencesFilterValues}>
      <MessageFilterProvider defaultFilterValues={defaultMessagesFilterValues}>
        <ResponsivePage.Body showHeader={false} variant="full" loading={false} error={null}>
          <PolicyPeriodDashboardContent />
        </ResponsivePage.Body>
      </MessageFilterProvider>
    </IncidenceFilterProvider>
  )
}

export default PolicyPeriodDashboardPage
